// extracted by mini-css-extract-plugin
export var alt = "ReservationsList-module--alt--ee541";
export var container = "ReservationsList-module--container--d644d";
export var desktopOnly = "ReservationsList-module--desktopOnly--9f7b9";
export var main = "ReservationsList-module--main--875e8";
export var mobileOnly = "ReservationsList-module--mobileOnly--408f7";
export var textLeft = "ReservationsList-module--textLeft--19835";
export var visuallyHidden = "ReservationsList-module--visuallyHidden--54792";